/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_First_NameInputs */

const en_profile_first_name = /** @type {(inputs: Profile_First_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First name`)
};

const es_profile_first_name = /** @type {(inputs: Profile_First_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre`)
};

/**
* | output |
* | --- |
* | "First name" |
*
* @param {Profile_First_NameInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const profile_first_name = /** @type {((inputs?: Profile_First_NameInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_First_NameInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_profile_first_name(inputs)
	return en_profile_first_name(inputs)
});